import { memo } from "react"

import type { IUserParticipantModel } from "@/3514/types"
import { buildCssClassName } from "@/3514/utils"
import Avatar from "@/shared/avatar/Avatar"

import { SimulabBadMessage } from "../messages/SimulabBadMessage"
import "../styles.scss"

type Props = {
    user: IUserParticipantModel
    text: string
    className?: string
}

export const ParticipantFeedbackBadMessage = memo(({ user, text, className = "" }: Props) => {
    return (
        <div className={buildCssClassName("participant-report-item", className)} data-testid="participant-report-item">
            <div className="participant-message-row">
                <div className="participant-message-row__wrapper">
                    <div className="participant-message-row__bubble">
                        <p className="m-0">{text}</p>
                    </div>
                    <Avatar url={user.photo} width={30} height={30} className="participant-message-row__avatar" />
                </div>
            </div>

            <SimulabBadMessage viewOnly className="p-0" />
        </div>
    )
})
